import { useEffect, useState } from "react";

/**
 * Total wall-clock time for the run, ticking while the build is live.
 *
 * Frozen once terminal: a timer that keeps counting after the build has ended
 * suggests something is still happening.
 */
export function useElapsed(createdAt: number | null, isTerminal: boolean): number | null {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (createdAt === null || isTerminal) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [createdAt, isTerminal]);

  return createdAt === null ? null : Math.max(0, now - createdAt);
}
